export { default as Header } from 'reports/components/historics/HistoricsReportHeader';
export { default as Table } from 'reports/components/historics/HistoricsReportTable';
export { default as Filters } from 'reports/components/historics/HistoricsReportFilters';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/historics/index.js